import { useCallback, useState } from 'react';
import fleetApi from '../../services/api.service';

const useRescheduleSteps = () => {
  const [isRescheduling, setIsRescheduling] = useState(false);
  const [error, setError] = useState(null);

  const rescheduleSteps = useCallback(async ({ tourPlanningIds, newTourDate }) => {
    setIsRescheduling(true);
    setError(null);

    try {
      if (!tourPlanningIds || tourPlanningIds.length === 0) {
        throw new Error('Aucune étape sélectionnée');
      }

      if (!newTourDate) {
        throw new Error('Une date de replanification est requise');
      }

      const response = await fleetApi.post('/tours-planning/steps/reschedule', {
        tour_planning_ids: tourPlanningIds,
        new_tour_date: newTourDate,
      });

      if (response.status === 200 && response.data?.success) {
        return {
          success: true,
          message: response.data?.message || 'Étapes replanifiées avec succès',
          data: response.data?.data,
        };
      }

      throw new Error('Réponse invalide du serveur');
    } catch (err) {
      const message =
        err?.response?.data?.message ||
        err.message ||
        'Impossible de replanifier les étapes';
      setError(message);
      throw new Error(message);
    } finally {
      setIsRescheduling(false);
    }
  }, []);

  const resetError = useCallback(() => {
    setError(null);
  }, []);

  return {
    rescheduleSteps,
    isRescheduling,
    error,
    resetError,
  };
};

export default useRescheduleSteps;
